module.exports = __webpack_public_path__ + "1ba289b91e827b75ff64dfd19bb31a8e.svg";